import PaymentDetailsContainer from "../../../../Components/Applications/Ecommerce/PaymentDetails/PaymentDetailsContainer";

const PaymentDetails = () => {
  return <PaymentDetailsContainer />;
};

export default PaymentDetails;
